import { editEngineering } from "@/services/createSpace/engineering";
import mixCutDetailStore from "@/stores/mixCutDetailStore";
import {
  initISencesItem,
} from "@/stores/quickCutStore/init";
import { IMaterialFile, ISences } from "@/stores/mixCutDetailStore/type";
import { ICaption } from "@/stores/mixCutDetailStore/type/caption";
import { Message } from "@arco-design/web-react";
import { IOpeatorTime } from "@/pages/VideoClips/MixCutDetail/VideoGroup/VideoGroupBlock/CutModal/CutModal";
import useMixCutDetailSave from "./useMixCutDetailSave";
import useMixCutDetail from "./useMixCutDetail";
import usePreview from "../preview/usePreview";
import { v4 as uuid } from "uuid";
import QuickCutStore from "@/stores/quickCutStore";
import ConfigStore from "@/stores/mixedConfig";
interface IUseVideoGroupReturn {
  projectSences: ISences[];
  projectCaption: ICaption[][];
  setProjectSences: (sences: ISences[]) => void;
  handleProjectName: (name: string) => void;
  handleProjectSencesAdd: (e: any) => void;
  handleProjectSencesDelete: (index: number) => void;
  handleProjectVideoChange: (index: number, data: IMaterialFile[]) => void;
  handleChangeVideoItemStartAndDuration: (
    groupIndex: number,
    index: number,
    data: IOpeatorTime,
  ) => void;
  toIdGetIsRepeat: (id: string) => boolean;
}

const useVideoGroup = (): IUseVideoGroupReturn => {
  const { general } = QuickCutStore.quickcutData.settings
  const { handleSaveMixCutDetailSave } = useMixCutDetailSave();
  const { findMaterialSetPreview } = usePreview();
  const toIdGetIsRepeat = (id: string) => {
    const allVideoMetarial = QuickCutStore.quickcutData.scenes
      .map((item) => item.materials)
      .flat(2);
    const sameIdLength = allVideoMetarial.filter(
      (item) => item.id === id,
    ).length;
    return sameIdLength > 1;
  };

  const handleChangeVideoItemStartAndDuration = (
    groupIndex: number,
    index: number,
    data: IOpeatorTime,
  ) => {
    const newMixCutDetailStoreSences = [
      ...QuickCutStore.quickcutData.scenes,
    ];
    newMixCutDetailStoreSences[groupIndex].materials[index].duration =
      data.duration;
    newMixCutDetailStoreSences[groupIndex].materials[index].start = data.start;
    newMixCutDetailStoreSences[groupIndex].materials[index].is_cropped = true;
    QuickCutStore.quickcutData.scenes = newMixCutDetailStoreSences;
    handleSaveMixCutDetailSave();
  };

  const handleProjectName = async (name: string) => {
    const msg = mixCutDetailStore.getProjectMsg();
    try {
      await editEngineering({ ...msg, title: name });
      mixCutDetailStore.setProjectMsg({ ...msg, title: name });
      Message.success("名称修改成功！");
    } catch (e) {
      Message.error(e);
      console.log(e);
    }
  };

  const handleProjectSencesAdd = (e: any) => {
    if (QuickCutStore.quickcutData.scenes?.length > 0) {
      const data = QuickCutStore.quickcutData.scenes.filter(item => item.type === 2 )
      if (data.length >= 15) {
        Message.error("镜头组最多15组，无法再次添加!");
      }
    }
    const scenes = [...QuickCutStore.quickcutData.scenes];
    // 先分离片头、片尾和中间镜头
    let start = scenes.find(item => item.type === 1);
    let end = scenes.find(item => item.type === 3);
    const middle = scenes.filter(item => !(item.type === 1) && !(item.type === 3));

    if (e === 1) {
      // 添加片头，若已有则不再添加
      if (!start) {
        start = { ...initISencesItem, id: uuid(), type: 1, name: '片头' };
      } else {
        Message.error('已存在片头，无法重复添加!');
        return;
      }
    }
    if (e === 3) {
      // 添加片尾，若已有则不再添加
      if (!end) {
        end = { ...initISencesItem, id: uuid(), type: 3, name: '片尾' };
      } else {
        Message.error('已存在片尾，无法重复添加!');
        return;
      }
    }
    if (e === 2) {
      // 添加普通镜头，插入到中间
      middle.push({ ...initISencesItem, id: uuid(), type: 2, name: '镜头名称', material_mute: general.mode !== 'origin'  });
    }

    // 重新组装顺序：片头 + 中间 + 片尾
    const newSences = [];
    if (start) newSences.push(start);
    newSences.push(...middle);
    if (end) newSences.push(end);

    // 保存到数据
    QuickCutStore.quickcutData.scenes = newSences;
    handleSaveMixCutDetailSave();
  };

  const handleProjectSencesDelete = (index: number) => {
    const sences = QuickCutStore.quickcutData.scenes ;
    if (sences.length === 1) {
      Message.error("项目中必须保留一个镜头组");
      return;
    }
    const newSences = sences.filter((_, i) => i !== index);
    QuickCutStore.quickcutData.scenes = newSences;
    // findMaterialSetPreview();
    handleSaveMixCutDetailSave();
  };

  const handleProjectVideoChange = (index: number, data: IMaterialFile[]) => {
    console.log(data, '素材')
    QuickCutStore.quickcutData.scenes[index].materials = data.map(item => {
      return {
        ...item,
        duration: item.duration > 0 ? item.duration : 3000,
        type: (item.type === 'PICTURE' || item.type === 3) ? 3 :  1,
      }
    })
    const newMixCutDetailStoreSences = [
      ...QuickCutStore.quickcutData.scenes,
    ];
    QuickCutStore.quickcutData.scenes = newMixCutDetailStoreSences
    // findMaterialSetPreview();
    handleSaveMixCutDetailSave();
  };

  const setProjectSences = (e) => {
    QuickCutStore.quickcutData.scenes = e
    // findMaterialSetPreview();
    handleSaveMixCutDetailSave();
  };

  return {
    projectCaption: mixCutDetailStore.getProjectCaption(),
    projectSences: QuickCutStore.quickcutData.scenes,
    setProjectSences: setProjectSences,
    handleProjectName,
    handleProjectSencesAdd,
    handleProjectSencesDelete,
    handleProjectVideoChange,
    handleChangeVideoItemStartAndDuration,
    toIdGetIsRepeat,
  };
};

export default useVideoGroup;
